export default __webpack_public_path__ + "static/media/rocket.4f93ba23.png";